//General
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MessageBoxComponent } from 'src/app/modals/message-box/message-box.component';
//Error
import { ErrorStateMatcher } from '@angular/material/core';
/** Error when invalid control is dirty, touched, or submitted. **/
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
//Servicio
import { MedicoService } from 'src/app/services/medico.service';
import { SesionService } from 'src/app/services/sesion.service';
//Detectar cambios de archivos
import { ChangeDetectorRef } from '@angular/core'; //Detectar cambios

@Component({
  selector: 'app-gestor-alm-incremento-inventario',
  templateUrl: './gestor-alm-incremento-inventario.component.html',
  styleUrls: ['./gestor-alm-incremento-inventario.component.scss'],
  providers: [ MedicoService ]
})
export class GestorAlmIncrementoInventarioComponent implements OnInit {

  //General
  public matcher: MyErrorStateMatcher = new MyErrorStateMatcher();
  public form: UntypedFormGroup = this.fb.group({
    buscador: new UntypedFormControl('', []),
    ruta: new UntypedFormControl('', []),
  });
  /*tabla*/
  public en_length: number = 100;;
  public en_pageSize: number = 25;
  public en_pageSizeOptions: Array<number> = [5, 10, 25, 100];
  public en_page: number = 1;
  public en_displayedColumns: any =[
    'en_foto', 
    'en_tipo',
    'en_nombre_medicamento',
    'en_presentacion',
    'en_entrada',
    'en_retiro',
    'en_consultar',
    //'en_modificar'
  ];
  public dataSource: any;
  /*fin tabla*/
  //All
  public accion: string = '';
  public isLoading: boolean = false;
  public laravelapi: any;
  public laravelapistorage: any;
  public acciones: any;
  public en_registrar: boolean = false;
  public en_consultar: boolean = false;
  public en_modificar: boolean = false;
  public en_eliminar: boolean = false;
  public t: any;

  constructor(
    private fb: UntypedFormBuilder,
    public  _dialog: MatDialog,
    private _medicoService_en: MedicoService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _sesionService_en:SesionService,
    private _cdRef:ChangeDetectorRef,
  ){ 
    this.getConsultaAltasMedicamento(1);
    this.laravelapi = this._medicoService_en.getLaravelApi();
    this.laravelapistorage = this._medicoService_en.getLaravelApiStorage();
    this.en_registrar = this.en_consultarAccionUsuario("/medico/almacen-de-medicamentos/gestor-incremento-inventario/registrar");
    this.en_consultar = this.en_consultarAccionUsuario("/medico/almacen-de-medicamentos/gestor-incremento-inventario/consultar");
    this.en_modificar = this.en_consultarAccionUsuario("/medico/almacen-de-medicamentos/gestor-incremento-inventario/modificar");
    this.en_eliminar = this.en_consultarAccionUsuario("/medico/almacen-de-medicamentos/gestor-incremento-inventario/eliminar");
  }

  ngOnInit(): void {
  }

  /*permisos*/
  public en_consultarAccionUsuario(url: any){
    if(this._sesionService_en.getSession().getUsuario().nombre != undefined){
      this.acciones = this._sesionService_en.getSession().getAcciones();
      console.log(this.acciones);
      if(this.acciones.filter(x => x.url == url)[0]){
        return true;        
      }else{
        return false;
      }
    }else{
      return false;
    }
  }
  /*fin permisos*/

  public getConsultaAltasMedicamento(page: number){
    this.isLoading = true;
    this.en_page = page;
    this._medicoService_en.getConsultaAltasMedicamento(this.en_page, this.en_pageSize, this.form.value.buscador).subscribe(
      response => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this.en_length = response.data.total;
          this.dataSource = response.data.data;
        }
      },
      error => {console.log(<any>error);
        this.isLoading = false;
      });
  }

  public pageEvent(event: any){
    console.info(event);
    this.en_pageSize = event.pageSize;
    this.getConsultaAltasMedicamento(event.pageIndex + 1);
  }

  ngAfterContentChecked() {
    this.t = new Date().getTime();
    this._cdRef.detectChanges();    
  }

}
